import React from "react";
import {IonButton, IonFab, IonFabButton, IonIcon} from "@ionic/react";
import MapDisplay from "../components/MapDisplay";
import {helpOutline} from "ionicons/icons";
import MobileMapLegend from "../components/MobileMapLegend";
import MobileMapExplanation from "../components/MobileMapExplanation";
import {IMapContainerProps} from "../utils/IMapContainerProps";
import './MobileContainer.css';
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Props for the operation of the map.
     */
    mapContainerProps: IMapContainerProps
}

/**
 * Component managing the display of the map on mobile.
 * @author Alizée Grand
 * @version 1.0
 * @creation 17/03/2022
 * @last_update 17/03/2022
 **/
class MobileContainer extends React.Component<Props> {

    /**
     * State of the component
     */
    state = {
        // If the modal displaying the legend is open or not
        showLegendPopup: false,
        // If the modal displaying the explanations is open or not
        showExplanationPopup: false,
    }

    render() {

        /**
         * Closes the popup containing the legend.
         */
        const onLegendPopupClick = () => {
            this.setState({showLegendPopup: false});
        };

        /**
         * Closes the popup containing the explanations.
         */
        const onExplanationPopupClick = () => {
            this.setState({showExplanationPopup: false});
        };

        /**
         * Open the popup containing the legend.
         */
        const onShowLegendButtonClick = () => {
            this.setState({showLegendPopup: true});
        }

        /**
         * Open the popup containing the explanations.
         */
        const onShowExplanationButtonClick = () => {
            this.setState({showExplanationPopup: true});
        }
        //TODO: Corriger affichage mobile lors du zoom
        return (
            <div id="mapMobileContainer">
                <IonButton id="buttonShowingLegend" size="large" expand="block" color="primary" onClick={onShowLegendButtonClick}>
                    {this.props.t("pages.map.legend.title")}
                </IonButton>
                <div id="mapDisplayMobileContainer">
                    <MapDisplay
                        gpsCoordinates={this.props.mapContainerProps.displayedOnMap.gpsCoordinates}
                        markers={this.props.mapContainerProps.displayedOnMap.markers}
                    />
                </div>
                <IonFab vertical="bottom" horizontal="end" slot="fixed" id="mapMobileFabButton" className="fabButton">
                    <IonFabButton onClick={onShowExplanationButtonClick}>
                        <IonIcon icon={helpOutline} />
                    </IonFabButton>
                </IonFab>
                <MobileMapLegend
                    showPopup={this.state.showLegendPopup}
                    onPopupDismiss={onLegendPopupClick}
                    onFilterClick={this.props.mapContainerProps.displayCorrectFilter}
                />
                <MobileMapExplanation isOpen={this.state.showExplanationPopup} onExplanationClick={onExplanationPopupClick}/>
            </div>
        );
    }

}

export default withTranslation()(MobileContainer);
